module.exports = __webpack_public_path__ + "img/logo.feccc2bc.png";